import type { NftMiniature } from "@anaconda/core/nft/types"

export function shouldShowBuyCta(
  nft: Pick<NftMiniature, "price" | "listingSource">,
  userOwnedNft?: boolean,
): boolean {
  if (userOwnedNft) return false
  return Boolean(nft.price)
}
